import { render, staticRenderFns } from "./SpecialNeedsStudentView.vue?vue&type=template&id=632b14c8&"
import script from "./SpecialNeedsStudentView.vue?vue&type=script&lang=js&"
export * from "./SpecialNeedsStudentView.vue?vue&type=script&lang=js&"
import style0 from "./SpecialNeedsStudentView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports